/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type ResetPasswordRequestInput = {|
  email: string
|};
export type ResetPasswordRequestMutationVariables = {|
  input: ResetPasswordRequestInput
|};
export type ResetPasswordRequestMutationResponse = {|
  +resetPasswordRequest: ?{|
    +ok: ?boolean
  |}
|};
export type ResetPasswordRequestMutation = {|
  variables: ResetPasswordRequestMutationVariables,
  response: ResetPasswordRequestMutationResponse,
|};
*/


/*
mutation ResetPasswordRequestMutation(
  $input: ResetPasswordRequestInput!
) {
  resetPasswordRequest(input: $input) {
    ok
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "ResetPasswordRequestPayload",
    "kind": "LinkedField",
    "name": "resetPasswordRequest",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "ok",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ResetPasswordRequestMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ResetPasswordRequestMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "bfeb65b04e03110dd9ebcb25ddcdde87",
    "id": null,
    "metadata": {},
    "name": "ResetPasswordRequestMutation",
    "operationKind": "mutation",
    "text": "mutation ResetPasswordRequestMutation(\n  $input: ResetPasswordRequestInput!\n) {\n  resetPasswordRequest(input: $input) {\n    ok\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'd7b3c1843c026e8bb08d813bb6fe5d35';

module.exports = node;
